var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat+Alternates:300,400,500,600,700|Montserrat:300,400,500,600,700|Raleway:300,400,500,600,700&display=swap);", ""]);

// module
exports.push([module.id, ".container-publications[data-v-29dd100d]{margin-bottom:2rem}.container-home[data-v-29dd100d]{padding-top:2rem;padding-bottom:2rem;background:linear-gradient(90deg,rgba(248,249,250,.85) 90%,rgba(248,249,250,.85)),url(" + escape(require("../../src/assets/fondo.svg")) + ") 100% no-repeat}@media (min-width:576px){.container-home[data-v-29dd100d]{padding-top:3rem;padding-bottom:3rem;background:linear-gradient(90deg,rgba(248,249,250,.7) 90%,rgba(248,249,250,.6)),url(" + escape(require("../../src/assets/fondo.svg")) + ") 100% no-repeat}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29dd100d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Index.vue
// module id = 405
// module chunks = 0